import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { Facility, IFacilityNote, NearestFacilityResult } from '../models/facility';
import { IIndexSearchRequest, ISearchMetadataResponse } from '../models/index-search';
import { FacilityRequest, IFacilityRequestSearchResponse } from './../models/facility-request';
import { ConfigurationService, ForceBaseUrl } from './configuration/configuration.service';
import { EndpointFactory } from './endpoint-factory.service';

@Injectable({
    providedIn: 'root'
})
export class FacilityEndpoint extends EndpointFactory {



    getServiceBaseUrl(force?: ForceBaseUrl) {
        return this.getBaseUrl('facility', force) + 'facility';
    }

    constructor(http: HttpClient, configurations: ConfigurationService, injector: Injector) {

        super(http, configurations, injector);
    }

    public fuzzySearch(body: IIndexSearchRequest): Observable<IFacilityRequestSearchResponse> {
        const endpointUrl = `${this.getServiceBaseUrl()}/fuzzysearch`;

        return this.http.post<IFacilityRequestSearchResponse>(endpointUrl, body).pipe(
            catchError(error => {
                return this.handleError(error);
            }));
    }

    public getMetaData(): Observable<ISearchMetadataResponse> {
        const endpointUrl = `${this.getServiceBaseUrl()}/searchmetadata`;

        return this.http.get<ISearchMetadataResponse>(endpointUrl).pipe(
            catchError(error => {
                return this.handleError(error);
            }));
    }

    public searchByCriteria(criteria: string): Observable<Facility[]> {

        const endpointUrl = `${this.getServiceBaseUrl()}/search?criteria=${criteria}`;

        return this.http.get<Facility[]>(endpointUrl).pipe<Facility[]>(
            catchError(error => {
                return this.handleError(error);
            }));
    }

    public byIds(ids: string[]): Observable<Facility[]> {

        const endpointUrl = `${this.getServiceBaseUrl()}/byids`;

        return this.http.post<Facility[]>(endpointUrl, ids).pipe<Facility[]>(
            catchError(error => {
                return this.handleError(error);
            }));
    }

    public getById(id: string): Observable<Facility> {

        const endpointUrl = `${this.getServiceBaseUrl()}/${id}/getfacility`;

        return this.http.get<Facility>(endpointUrl).pipe<Facility>(
            catchError(error => {
                return this.handleError(error);
            }));
    }

    public getFacilityRequest(memberId: string, tenantId: string, facilityRequestId: string) {
        const endpointUrl = `${this.getServiceBaseUrl()}/${memberId}/${tenantId}/${facilityRequestId}`;

        return this.http.get<FacilityRequest>(endpointUrl).pipe(
            catchError(error => {
                return this.handleError(error);
            })
        );

    }

    getFacilityRequestNotes(base64: string, facilityExternalId: string): Observable<IFacilityNote[]> {
        const endpointUrl = `${this.getServiceBaseUrl()}/${base64}/facilityrequest/${facilityExternalId}/notes`;

        return this.http.get<IFacilityNote[]>(endpointUrl).pipe(
            catchError(error => {
                return this.handleError(error);
            })
        );
    }

    public addFacilityRequestNote(base64: string, facilityExternalId: string, note: IFacilityNote): Observable<IFacilityNote> {
        const endpointUrl = `${this.getServiceBaseUrl()}/${base64}/facilityrequest/${facilityExternalId}/note`;

        return this.http.post<IFacilityNote>(endpointUrl, note).pipe(
            catchError(error => {
                return this.handleError(error);
            })
        );
    }

    advanceStage(base64: string, facilityRequestExternalId: string, action: string, reason: any) {
        const endpointUrl = `${this.getServiceBaseUrl()}/${base64}/facilityrequest/${facilityRequestExternalId}/advance/${action}`;

        return this.http.put<any>(endpointUrl, { reason }).pipe(
            catchError(error => {
                return this.handleError(error);
            })
        );
    }

}
